import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComment = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.66659 8.75H13.3333M6.66659 12.0833H9.16659M17.5032 10C17.5032 14.1421 14.1453 17.5 10.0032 17.5C8.30617 17.5 2.50378 17.5 2.50378 17.5C2.50378 17.5 3.8031 14.3801 3.2831 13.334C2.78388 12.3297 2.50317 11.1976 2.50317 10C2.50317 5.85786 5.86103 2.5 10.0032 2.5C14.1453 2.5 17.5032 5.85786 17.5032 10Z",
		stroke: "#667099",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgComment;
